/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raffle_LatestInputs */



/**
* | output |
* | --- |
* | "Latest" |
*
* @param {Raffle_LatestInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const raffle_latest = /** @type {((inputs?: Raffle_LatestInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raffle_LatestInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dernier")
	if (locale === "es") return /** @type {LocalizedString} */ ("Más reciente")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Mais recente")
	if (locale === "it") return /** @type {LocalizedString} */ ("Più recente")
	return /** @type {LocalizedString} */ ("Latest")
});